import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import ProfilePage from '../pages/ProfilePage';
import { useTheme } from '../context/ThemeContext';
import '../styles/ProfileDrawer.css';

const ProfileDrawer = ({ userId, onClose }) => {
  const { theme } = useTheme();
  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEsc);

    // Lock scroll — both html and body to cover all layouts
    const targets = [document.documentElement, document.body];
    targets.forEach(el => { el._drawerPrevOverflow = el.style.overflow; el.style.overflow = 'hidden'; });

    return () => {
      document.removeEventListener('keydown', handleEsc);
      targets.forEach(el => { el.style.overflow = el._drawerPrevOverflow || ''; });
    };
  }, [onClose]);

  // Portal to body: escapes any ancestor with backdrop-filter/transform,
  // which would otherwise become the containing block for position:fixed
  // and break the drawer height / scrolling.
  return createPortal(
    <div className={`drawer-overlay theme-${theme}`} onClick={onClose}>
      <div className="drawer-panel" onClick={e => e.stopPropagation()}>
        <button className="drawer-close" onClick={onClose} aria-label="Close">✕</button>
        <div className="drawer-content">
          <ProfilePage userId={userId} onClose={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProfileDrawer;
